import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Campeonato2023 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 139; i <= 157; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	kits:[],
        kit_path: '/images_fem/kits/todas/',
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
      table2:[{'color':'#E42727','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':13, 'pg':5,'pe':2,'pp':6,'gf':27,'gc':28,'dif':-1, 'pts':17},
              {'color':'#E42727','shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':13, 'pg':6,'pe':1,'pp':6,'gf':18,'gc':33,'dif':-15, 'pts':19},
              {'color':'#295e1e','shortname':'coquimbo', 'rivalName':'Coquimbo U.', 'pj':13, 'pg':6,'pe':3,'pp':4,'gf':24,'gc':22,'dif':2, 'pts':21},
              {'color':'#E42727','shortname':'vial', 'rivalName':'Fernández Vial', 'pj':13, 'pg':1,'pe':0,'pp':12,'gf':10,'gc':43,'dif':-33, 'pts':3},
              {'color':'#E42727','shortname':'cobresal', 'rivalName':'Cobresal', 'pj':13, 'pg':3,'pe':4,'pp':6,'gf':14,'gc':25,'dif':-11, 'pts':13},
              {'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':13, 'pg':11,'pe':0,'pp':2,'gf':63,'gc':7,'dif':56, 'pts':33},
              {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':13, 'pg':12,'pe':0,'pp':1,'gf':57,'gc':9,'dif':48, 'pts':36},
                {'color':'#295e1e','shortname':'palestino', 'rivalName':'Palestino', 'pj':13, 'pg':6,'pe':2,'pp':5,'gf':30,'gc':16,'dif':14, 'pts':20},
                {'color':'#E42727','shortname':'audax', 'rivalName':'A. Italiano', 'pj':13, 'pg':4,'pe':3,'pp':6,'gf':21,'gc':32,'dif':-11, 'pts':15},
                {'color':'#295e1e','shortname':'catolica', 'rivalName':'U. Católica', 'pj':13, 'pg':6,'pe':2,'pp':5,'gf':31,'gc':26,'dif':5, 'pts':20},
                {'color':'#E42727','shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':13, 'pg':1,'pe':1,'pp':11,'gf':10,'gc':53,'dif':-43, 'pts':4},
                {'color':'#295e1e','shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':13, 'pg':8,'pe':1,'pp':4,'gf':33,'gc':30,'dif':3, 'pts':25},
                {'color':'#295e1e','shortname':'morning', 'rivalName':'S. Morning', 'pj':13, 'pg':8,'pe':1,'pp':4,'gf':36,'gc':18,'dif':18, 'pts':25},
              {'color':'#E42727','shortname':'puertomontt', 'rivalName':'Pto. Montt', 'pj':13, 'pg':4,'pe':0,'pp':9,'gf':17,'gc':49,'dif':-32, 'pts':12}],
	table3:
		[{'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':6, 'pg':3,'pe':1,'pp':2,'gf':10,'gc':11,'dif':-1, 'pts':10},
              {'color':0,'shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':6, 'pg':3,'pe':3,'pp':0,'gf':10,'gc':4,'dif':6, 'pts':12},
              {'color':'#ffa233','shortname':'vial', 'rivalName':'Fernández Vial', 'pj':6, 'pg':2,'pe':3,'pp':1,'gf':11,'gc':9,'dif':2, 'pts':9},
              {'color':'#ffa233','shortname':'cobresal', 'rivalName':'Cobresal', 'pj':6, 'pg':3,'pe':0,'pp':3,'gf':8,'gc':8,'dif':0, 'pts':9},
                {'color':0,'shortname':'audax', 'rivalName':'A. Italiano', 'pj':6, 'pg':3,'pe':1,'pp':2,'gf':10,'gc':11,'dif':-1, 'pts':10},
                {'color':'#E42727','shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':6, 'pg':0,'pe':1,'pp':5,'gf':6,'gc':15,'dif':-9, 'pts':1},
              {'color':'#E42727','shortname':'puertomontt', 'rivalName':'Pto. Montt', 'pj':6, 'pg':2,'pe':1,'pp':3,'gf':8,'gc':9,'dif':-1, 'pts':7}]

    };
  }

  componentDidMount() {
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});
		let newtable2 = this.sortTable(this.state.table3);
                this.setState({table3:newtable2});
		this.getKits();
	}

 getKits(){

        fetch("https://www.registrosudec.com:5000/kits_femenino", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a Grupo A');
  let subC = this.subText('#E42727', 'Clasificado a Grupo B');
 let subD = this.subText('#E42727', 'Desciende a Primera B');
 let subP = this.subText('#ffa233', 'Juega liguilla descenso');
  return(

	<div style={{textAlign: 'center' }}>
	      <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Campeonato 2023</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Primera Fase </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subT}
	 {subC}

	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Grupo B</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table3} />}
        <div style={{ height: '10px' }}></div>
         {subP}
	  {subD}
	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Campeonato 2023</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Campeonato 2023</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Campeonato 2023" />
     </div>


  )
}

}
export default Campeonato2023;
